/* Joyeux Marché — module « fête » (26/10). Effets ponctuels, sans dépendance, coupés si les animations sont réduites. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return mq.matches || root.classList.contains('jm-reduced'); }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function swing(el) { if (reduced()) return; el.classList.remove('is-swinging'); void el.offsetWidth; el.classList.add('is-swinging'); }

  /* 1. Boules suspendues sur l'en-tête des rayons : balancement à l'arrivée et au survol */
  function baubles() {
    var inner = d.querySelector('.jm-chero__inner'); if (!inner || inner.querySelector('.jm-bauble')) return;
    var defs = [['l', '#B3202A', 34, 0], ['r', '#1E4D3B', 44, .15], ['r2', '#C99A3B', 26, .3]];
    defs.forEach(function (b) {
      var s = d.createElement('span');
      s.className = 'jm-bauble jm-bauble--' + b[0]; s.setAttribute('aria-hidden', 'true');
      s.style.setProperty('--c', b[1]); s.style.setProperty('--len', b[2] + 'px'); s.style.setProperty('--sd', b[3] + 's');
      s.appendChild(d.createElement('i'));
      inner.appendChild(s);
      s.firstChild.addEventListener('pointerenter', function () { s.style.setProperty('--sd', '0s'); swing(s); });
      setTimeout(function () { swing(s); }, 300);
    });
  }

  /* 2. Compte à rebours qui défile jusqu'au nombre de jours (une fois par visite) */
  function countUp() {
    var n = d.querySelector('[data-jm-countdown] [data-num]'); if (!n) return;
    var target = parseInt(n.textContent, 10);
    if (!(target > 1) || reduced() || sget('jm_countup') || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return; io.disconnect(); sset('jm_countup', '1');
      var t0 = performance.now(), dur = 1100;
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        n.textContent = Math.round(target * e);
        if (p < 1) requestAnimationFrame(step); else n.textContent = target;
      })(t0);
    });
    io.observe(n);
  }

  /* 3. Reflet doré sur les titres de rayon et de section, une fois, quand ils apparaissent */
  function shine() {
    if (reduced() || !('IntersectionObserver' in window)) return;
    var els = d.querySelectorAll('.jm-chero__title, .jm-section-title'); if (!els.length) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return; io.unobserve(x.target);
        var el = x.target; el.style.setProperty('--jm-ink', getComputedStyle(el).color);
        el.classList.add('jm-shine');
        setTimeout(function () { el.classList.remove('jm-shine'); }, 1700);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 4. Brillance unique sur le bouton « Ajouter au panier » à l'ouverture d'une fiche */
  function atcShine() {
    if (reduced()) return;
    var b = d.querySelector('main .add-to-cart-button:not(.sticky-add-to-cart__button)'); if (!b) return;
    setTimeout(function () { b.classList.add('jm-atc-shine'); setTimeout(function () { b.classList.remove('jm-atc-shine'); }, 1600); }, 1200);
  }

  function init() { baubles(); countUp(); shine(); atcShine(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
